import Summer from "../../../../src/events/2021/07/event-summer/summer";
import * as React from 'react';
export default {
  Summer,
  React
};